import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index'
import tool from '@/utils/tool'
import {Toast} from 'vant';
import NProgress from 'nprogress'
import routes_system from './modules/system'
import 'nprogress/nprogress.css' // progress bar style

Vue.use(VueRouter)

/**
 * 因为路由有优先级的概念，先定义的会先匹配，而自动注册是依据文件名的排序来遍历的
 * 所以下面这种情况，如果访问 /news/edit ，会指向到 info.vue 页面上
 * a.js   /news/:id   info.vue
 * b.js   /news/edit   edit.vue
 * 为避免这种情况发生，同一模块下的路由必须放在一个路由配置文件里
 * 按上面的例子，news 模块的路由，应该放到一个类似于 news.js 的文件里
 * 至于模块里的路由优先级，可以把 /news/edit 放在 /news/:id 前面，或者把 /news/:id 改成 /news/info/:id 均可
 */

// 先定义路由处理函数，避免在调用时未定义
//转换
function filterAsyncRouter(routerMap) {
    const accessedRouters = []
    routerMap.forEach(item => {
        item.meta = item.meta ? item.meta : {};
        //处理外部链接特殊路由
        //MAP转路由对象
        var route = {
            path: item.path,
            name: item.name ? item.name : parseRouteName(item.path),
            meta: item.meta,
            redirect: item.redirect,
            children: item.children ? filterAsyncRouter(item.children) : null,
            component: loadComponent(item)
        }
        accessedRouters.push(route)
    })
    return accessedRouters
}

// 解析路由Name
function parseRouteName(path) {
    let arr = path.split('/')
    let name = '';
    arr.forEach(item => {
        if (name == '') {
            name = item
        } else {
            name += firstToUpper(item)
        }
    });
    return name
}

// 首字母转大写
function firstToUpper(str) {
    str = str.trim()
    return str.toLowerCase().replace(str[0], str[0].toUpperCase());
}

function loadComponent(item) {
    if (item && (item.component || item.path)) {
        if (item.component) {
            return () =>
                import(`@/views/${item.component}`)
        } else {
            return () =>
                import(`@/views/${item.path}`)
        }
    } else {
        return () =>
            import('@/views/404')
    }
}

//路由扁平化
function flatAsyncRoutes(routes, breadcrumb = []) {
    let res = []
    routes.forEach(route => {
        const tmp = {...route}
        if (tmp.children) {
            let childrenBreadcrumb = [...breadcrumb]
            childrenBreadcrumb.push(route)
            let tmpRoute = {...route}
            tmpRoute.meta.breadcrumb = childrenBreadcrumb
            delete tmpRoute.children
            res.push(tmpRoute)
            let childrenRoutes = flatAsyncRoutes(tmp.children, childrenBreadcrumb)
            childrenRoutes.map(item => {
                res.push(item)
            })
        } else {
            let tmpBreadcrumb = [...breadcrumb]
            tmpBreadcrumb.push(tmp)
            tmp.meta.breadcrumb = tmpBreadcrumb
            res.push(tmp)
        }
    })
    return res
}

const routes = [...routes_system] // 浅拷贝即可，避免深拷贝导致的问题
let routes_user = [];
const require_module = require.context('./modules', false, /.js$/)
require_module.keys().forEach(file_name => {
    if (file_name.indexOf('system') < 0) {
        let list = require_module(file_name).default;
        list.forEach(function (item) {
            routes_user.push(item)
        });
    }
})

// 在初始化 router 之前，将动态路由添加到 Layout 的 children 中
if (routes_user.length > 0) {
    var menuRouter = filterAsyncRouter(routes_user)
    menuRouter = flatAsyncRoutes(menuRouter)

    // 找到 Layout 路由并将动态路由添加到其 children
    const layoutRoute = routes.find(r => r.name === 'Layout')
    if (layoutRoute && menuRouter.length > 0) {
        layoutRoute.children = [...(layoutRoute.children || []), ...menuRouter]
    }
}

const router = new VueRouter({
    routes: routes
})

router.onError((error) => {
    console.error('路由错误', error)
    NProgress.done();
    if (error.message.indexOf('Loading chunk') > -1 && tool.data.get('reloadTime') < (new Date()).getTime()) {
        // 旧资源缓存导致找不到，强制刷新一次
        tool.data.set('reloadTime', (new Date()).getTime() + 600 * 1000)
        window.location.reload()
    } else {
        Toast.fail(error.message);
    }

});


// 解决路由在 push/replace 了相同地址报错的问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    const result = originalPush.call(this, location)
    return result && typeof result.catch === 'function' ? result.catch(err => err) : result
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
    const result = originalReplace.call(this, location)
    return result && typeof result.catch === 'function' ? result.catch(err => err) : result
}

// 定义404页面路由（Vue Router 3.x 使用 * 作为通配符，而不是 /:pathMatch(.*)*）
router.addRoutes([{
    path: "*",
    component: () =>
        import('@/views/404'),
    meta: {
        title: '找不到页面'
    }
}]);

const config = store.state.config.data;

var title = config ? config['title'] : tool.data.get('title');
var sitename = config ? config['sitename'] : tool.data.get('sitename');
if (store.getters['token/isLogin']) {
    store.dispatch('token/getUserInfo');
}

const hasOwnProperty = function (obj, key) {
    if ('object' !== typeof obj) {
        return false;
    }
    return Object.prototype.hasOwnProperty.call(obj, key);
}

var $_GET = (function () {
    var url = window.document.location.href.toString();
    var u = url.split("?");
    if (typeof (u[1]) == "string") {
        u = u[1].split("&");
        var get = {};
        for (var i in u) {
            var j = u[i].split("=");
            get[j[0]] = j[1];
        }
        return get;
    } else {
        return {};
    }
})();

var $_QUERY = (function () {
    var url = window.document.location.href.toString();
    var u = url.split("?", 2);
    return u[1];
})();


if ($_GET && hasOwnProperty($_GET, 'go') && $_GET.go.substring(0, 1) == '/') {
    // console.log('$_GET', $_GET);
    window.location.href = '//' + window.location.host + '/#' + $_GET.go.trim() + '?' + $_QUERY;
    // next({
    //     path: $_GET.go.trim(),
    //     query: $_GET
    // })
}

//动态标题
router.beforeEach((to, from, next) => {
    NProgress.start()
    if (to.path != '/index' && to.path == '/') {
        sitename = sitename ? sitename : '云店'
        if (to.path == '/index' || to.path == '/') {
            document.title = title ? `${sitename} - ${title}` : `${sitename}`
        } else {
            document.title = to.meta.title ? `${sitename} - ${to.meta.title}` : `${sitename}`
        }
    }
    // console.log('to', to);
    //整页路由处理
    if (to.meta.fullpage) {
        to.matched = [to.matched[to.matched.length - 1]]
    }

    if (to.path.startsWith('/user')) {
        const publicPages = ['/user/login', '/user/register', 'user/order/index', 'user/order/desc', '/user/findpwd', '/user/kefu']
        const authRequired = !publicPages.includes(to.path)

        if (authRequired && !store.getters['token/isLogin']) {
            NProgress.done()
            return next({
                path: '/user/login',
                query: {redirect: to.fullPath}
            })
        }
    }
    NProgress.done();
    next();
});

export default router


// WEBPACK FOOTER //
// ./src/router/index.js